import { Link } from "react-router";
import { XCircle } from "lucide-react";
import { LOGIN_PATH } from "@/features/auth/routes";
import type { TransferRequest } from "@/features/employeeTransfer/types/employeeTransfer.types";
import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

type RefusedScreenProps = { transferRequest: TransferRequest };

export const RefusedScreen = ({ transferRequest }: RefusedScreenProps) => {
  const { source_organization_name: sourceOrg } = transferRequest;

  return (
    <div className="overflow-hidden rounded-xl" aria-live="polite">
      <div className="bg-gray-50/80 px-6 py-8 dark:bg-gray-800/30">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 dark:bg-red-700/50">
            <XCircle size={28} className="text-red-500 dark:text-red-400" />
          </div>
          <H2 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
            Transfert refusé
          </H2>
          <P size="sm" color="base" className="text-balance tracking-wider">
            Votre compte reste inchangé et rattaché à
            {" "}
            <strong className="text-gray-900 dark:text-white">{sourceOrg}</strong>
            .
          </P>
        </div>
      </div>

      <div className="space-y-4 px-6 pb-6 pt-4">
        <div className="space-y-4 rounded-lg border border-gray-100 bg-gray-50 p-4 text-left dark:border-gray-700 dark:bg-gray-800/50">
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Aucune donnée n'a été transférée.
          </P>
          <P size="sm" color="base" className="text-pretty tracking-wider">
            Si cette demande était une erreur,
            vous pouvez contacter votre CSE pour en discuter.
          </P>
        </div>

        <Link
          to={LOGIN_PATH}
          className="block w-full rounded-lg border border-gray-200 bg-white px-6 py-3 text-center text-base font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 dark:focus:ring-gray-600 dark:focus:ring-offset-gray-900"
        >
          Retour à la connexion
        </Link>
      </div>
    </div>
  );
};
